import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { getUtilityIcon } from 'utils/utilityTypeUtils/utilityTypeUtils';
// import { numericFormatter } from 'react-number-format';
// import i18next from 'i18next';
import Tippy from '@tippyjs/react';
import { numericFormatter } from 'react-number-format';
import { TableProgressBar } from 'pages/Management/ProjectListPage/components';
import { useTranslation } from 'react-i18next';

interface AnomaliesTableColumnsReturnType {
  columns: ColumnDef<any, any>[];
}

const useGetOrganizationProjectsTableColumns =
  (): AnomaliesTableColumnsReturnType => {
    const { t } = useTranslation();
    const columnHelper = createColumnHelper<any>();

    const columns = [
      columnHelper.accessor('name', {
        header: () => t('organizationView.projects.columns.projectName'),
        cell: (info) => {
          const values = info.row.original;
          return (
            <Tippy content={info.getValue()} maxWidth={450}>
              <span className="flex items-center gap-2.5">
                <div className="fill-gray-50">
                  {getUtilityIcon(values.utility_type)}
                </div>
                <span className="max-w-[120px] desktop-l:max-w-[150px] block text-ellipsis overflow-hidden truncate">
                  {info.renderValue()}
                </span>
              </span>
            </Tippy>
          );
        },
        enableSorting: true,
        size: 100,
        maxSize: 200,
      }),
      columnHelper.accessor('building_name', {
        header: () => t('organizationView.projects.columns.building'),
        cell: (info) => {
          return (
            <Tippy content={info.getValue()} maxWidth={450}>
              <span className="flex items-center gap-2.5">
                <span className="block text-ellipsis overflow-hidden truncate max-w-[180px]">
                  {info.renderValue()}
                </span>
              </span>
            </Tippy>
          );
        },
        enableSorting: true,
        size: 100,
        maxSize: 100,
      }),
      columnHelper.accessor('distance_from_target', {
        id: 'distance_from_target',
        header: () => <></>,
        cell: (info) => {
          const values = info.row.original;
          const completed = parseFloat(
            numericFormatter(((values?.savings_rel ?? 0) * 100).toString(), {
              decimalSeparator: ',',
              thousandSeparator: '.',
              decimalScale: 1,
            })
          );
          const maxCompleted = parseFloat(
            numericFormatter(((values?.savings_target ?? 0) * 100).toString(), {
              decimalSeparator: ',',
              thousandSeparator: '.',
              decimalScale: 1,
            })
          );
          return (
            <TableProgressBar
              enableNegativeBar={true}
              completed={completed}
              maxCompleted={maxCompleted}
              maxWidth={120}
            />
          );
        },
        size: 100,
        maxSize: 200,
      }),
    ];

    return {
      columns,
    };
  };
export default useGetOrganizationProjectsTableColumns;
